import { GeofenceRule, GeofenceRuleCreation } from 'services/resources';
import {
  startLoading,
  receivedGeofencesSuccess,
  receivedGeofencesFail,
  receivedAddGeofencesSuccess,
  receivedAddGeofencesFail,
  receivedUpdateGeofencesSuccess,
  receivedUpdateGeofencesFail,
  receivedDeleteGeofenceSuccess,
  receivedDeleteGeofenceFail,
  receivedGetGeofenceRulesSuccess,
  receivedGetGeofenceRulesFail,
  receivedUpdateGeofenceRuleSuccess,
  receivedUpdateGeofenceRuleFail,
  receivedCreateGeofenceRuleSuccess,
  receivedCreateGeofenceRuleFail,
  receivedDeleteGeofenceRuleSuccess,
  receivedDeleteGeofenceRuleFail,
} from './actions';

import {
  geofences,
  createUpdateGeofence,
  deleteGeofence,
  getGeofenceRules,
  patchGeofenceRule,
  postGeofenceRule,
  deleteGeofenceRuleRequest,
} from './resources';

import { AppDispatch } from 'store';

/**
 * Gets the fleet settings alerts
 */
export const getGeofences = () => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  return geofences()
    .then((response) => {
      dispatch(receivedGeofencesSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedGeofencesFail(response.data));
    });
};

/**
 * Adds a new geofence
 */
export const addGeofence = (name: string, geofence: object) => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
  return createUpdateGeofence(name, geofence)
    .then((response) => {
      dispatch(receivedAddGeofencesSuccess(response));

      return response.id;
    })
    .catch((response) => {
      dispatch(receivedAddGeofencesFail(response.data));

      throw response;
    });
};

/**
 * Updates a geofence
 */
export const updateGeofence = (id: number, name: string, geofence: object) => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  return createUpdateGeofence(name, geofence, id)
    .then((response) => {
      dispatch(receivedUpdateGeofencesSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedUpdateGeofencesFail(response.data));

      return Promise.reject();
    });
};

/**
 * Deletes a geofence
 */
export const removeGeofence = (id: number) => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  return deleteGeofence(id)
    .then(() => {
      dispatch(receivedDeleteGeofenceSuccess(id));
    })
    .catch((response) => {
      dispatch(receivedDeleteGeofenceFail(response.data));

      return Promise.reject();
    });
};

/**
 * List GeofenceRules
 */
export const listGeofenceRules = () => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  return getGeofenceRules()
    .then((response) => {
      dispatch(receivedGetGeofenceRulesSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedGetGeofenceRulesFail(response.data));
    });
};

/**
 * Partially Update a GeofenceRule
 */
export const updateGeofenceRule =
  (id: number, rule: Partial<Pick<GeofenceRule, 'name' | 'isActive' | 'onEntry' | 'onExit' | 'actions'>>) =>
  (dispatch: AppDispatch) => {
    dispatch(startLoading());

    return patchGeofenceRule(id, rule)
      .then((response) => {
        dispatch(receivedUpdateGeofenceRuleSuccess(response));
      })
      .catch((response) => {
        dispatch(receivedUpdateGeofenceRuleFail(response.data));

        return Promise.reject();
      });
  };

/**
 * Create a GeofenceRule
 */
export const addGeofenceRule = (rule: GeofenceRuleCreation) => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  return postGeofenceRule(rule)
    .then((response) => {
      dispatch(receivedCreateGeofenceRuleSuccess(response));
    })
    .catch((response) => {
      dispatch(receivedCreateGeofenceRuleFail(response.data));

      return Promise.reject();
    });
};

/**
 * Delete a GeofenceRule
 */
export const deleteGeofenceRule = (id: number) => (dispatch: AppDispatch) => {
  dispatch(startLoading());

  return deleteGeofenceRuleRequest(id)
    .then(() => {
      dispatch(receivedDeleteGeofenceRuleSuccess(id));
    })
    .catch((response) => {
      dispatch(receivedDeleteGeofenceRuleFail(response.data));

      return Promise.reject();
    });
};
